import { Icon, Tooltip } from '@blueprintjs/core';
import { useContext } from 'react';
import {
  lock_hooks,
  useApplicationDetail,
  usePerson,
} from '@axo/shared/data-access/hooks';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { IconButton } from '../IconButton';
import styles from './Navigation.module.css';
import { IApplication } from '../../store/state';
import { getApplicationTabLabel } from './ApplicationTabLabel';
import { useAssignments } from '../../hooks/utils/useAssignments';

interface INavTabProps {
  application: IApplication;
  isSelected: boolean;
  closeTab: (e: React.MouseEvent, application: IApplication) => Promise<void>;
}

export function NavTab({ application, closeTab }: INavTabProps) {
  const { processedAt } = useAssignments({
    applicationID: application.applicationID,
    marketCountry: application.marketCountry,
  });

  const lock = lock_hooks.useApplicationLock(
    application.applicationID,
    application.marketCountry
  );
  const detail = useApplicationDetail(application.applicationID);
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);
  const person = usePerson(detail.data?.PersonID);
  const label = getApplicationTabLabel(detail, person);

  return (
    <>
      <div className={styles.tabTitle}>
        {lock.isSuccess && lock.data?.LockedBy !== clientID && (
          <Tooltip
            content={
              <>
                {!lock.data?.LockedBy && (
                  <span>The application is unlocked.</span>
                )}
                {lock.data?.LockedBy && lock.data.LockedBy !== clientID && (
                  <span>The application is locked by another user.</span>
                )}
              </>
            }
          >
            <Icon icon="unlock" intent="none" />
          </Tooltip>
        )}
        <Tooltip
          disabled={!detail.data}
          content={`${detail.data?.Product} application: ${application.humanReadableID}`}
        >
          <span>{label}</span>
        </Tooltip>
        {processedAt && (
          <Tooltip content={<span>The application is processed.</span>}>
            <Icon className={styles.processedIcon} icon="tick" />
          </Tooltip>
        )}
      </div>
      <span className={styles.fade}>
        <Tooltip
          content="Close and unlock application"
          className={styles.closeButton}
        >
          <IconButton
            iconPlacement="right"
            icon="delete"
            onClick={(e) => closeTab(e, application)}
          />
        </Tooltip>
      </span>
    </>
  );
}
